import { LISTAR_GRUPOS_RAMAIS, LISTAR_GRUPO_RAMAL_SELECIONADO, LISTAR_RAMAIS } from './mutation-types'

import GruposRamaisHttpService from '../_services/GruposRamaisHttpService'

export default {
  listarGruposRamais: async ({ commit }) => {
    try {
      const response = await GruposRamaisHttpService.getGruposRamais()
      commit(LISTAR_GRUPOS_RAMAIS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarGrupoRamalSelecionado: async ({ commit }, _id) => {
    try {
      const response = await GruposRamaisHttpService.getGrupoRamal(_id)
      commit(LISTAR_GRUPO_RAMAL_SELECIONADO, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarRamais: async ({ commit }) => {
    try {
      const response = await GruposRamaisHttpService.getRamais()
      commit(LISTAR_RAMAIS, response.data)
    } catch (e) {
      console.log(e)
    }
  },
}
